// Copyright 2026 FlairCV Contributors
// SPDX-License-Identifier: AGPL-3.0-or-later

import { createClient } from '@flaircv/api-client';
import { authMiddleware } from './auth-middleware';

/**
 * Singleton API client for the web app.
 * Uses the Vite dev server proxy — base URL is empty so requests
 * go to the same origin (e.g. POST /api/v1/auth/login).
 *
 * The auth middleware automatically:
 * - Attaches Authorization header on authenticated requests
 * - Intercepts 401 responses, refreshes the token, and retries
 */
export const apiClient = createClient('');

// Register the auth middleware for automatic token management.
apiClient.use(authMiddleware);
